import React from "react";

export const CreateTransfer = ({ setStep, setFlow, payload, setPayload }) => {

  const handleSubmit = (type) => {
    setFlow(type);
    setPayload({ ...payload, flow: type }); // Update payload with the selected type
    if (type === "stored") setStep(2.1);
    else if (type === "new") setStep(2.2);
  }

  return (
    <>
      <div className="create-transfer-header">
        <h4 className="create-transfer-title"><span className="yellow">Create</span> Transfer</h4>
      </div>
      <div className="create-transfer-body-content">
        <div className="create-transfer-description">
          Would you like to send a transfer to a stored recipient or create a new recipient to send a transfer to?
        </div>
        <div className="create-transfer-actions">
          <button className="secondary__btn" type="submit" onClick={() => handleSubmit("stored")}>Stored Recipient</button>
          <button className="primary__btn" type="submit" onClick={() => handleSubmit("new")}>New Recipient</button>
        </div>
      </div>
    </>
  );
};
